var SideMenuItemType;
(function (SideMenuItemType) {
    SideMenuItemType["DROPDOWN"] = "DROPDOWN";
    SideMenuItemType["LINK"] = "LINK";
    SideMenuItemType["NESTED"] = "NESTED";
})(SideMenuItemType || (SideMenuItemType = {}));
export { SideMenuItemType, };
//# sourceMappingURL=SideMenu.types.js.map